// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2qSox","modalForm":"UpgradeEpcsModal_modalForm__1d-4G","modalFooter":"UpgradeEpcsModal_modalFooter__12yKg"};